export default "__VITE_ASSET__DeKni$RA__"